import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  addHobby,
  deleteHobby,
  getHobby,
  updateHobby,
} from "store/services/dataManagement/hobby";
import { uploadFile } from "store/services/utilities";
import { closeAdminModal } from "store/slices/common/adminModal.slice";
import { openToast } from "store/slices/common/toast.slice";
import { getApiMessage } from "utils/apiErrorCode";

//Get All Hobby
export const GetAllHobbyAction = createAsyncThunk(
  "hobby/get",
  async (payload, { rejectWithValue, fulfillWithValue }) => {
    try {
      const res = await getHobby(payload);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        return fulfillWithValue(res);
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

//Delete Hobby
export const DeleteHobbyAction = createAsyncThunk(
  "hobby/delete",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const { filter, onSuccess, ...rest } = payload;
      const res = await deleteHobby(rest);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        if (onSuccess) onSuccess();
        const responce = await getHobby(filter);
        if (responce.status === 1) {
          return fulfillWithValue(responce);
        }
      }
      dispatch(
        openToast({ type: "error", message: getApiMessage(res?.statusCode) }),
      );
      return rejectWithValue(res);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      return rejectWithValue(error);
    }
  },
);

//Update Hobby
export const UpdateHobbyAction = createAsyncThunk(
  "hobby/update",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    let { file, onSucess, onError, ...rest } = payload;
    try {
      if (file) {
        const uploadFilesResponse = await uploadFile({
          file: file,
          uploadFor: "image",
        });

        if (uploadFilesResponse.status === 0) {
          dispatch(
            openToast({ type: "error", message: uploadFilesResponse?.message }),
          );
          return rejectWithValue(uploadFilesResponse);
        }
        rest.image = uploadFilesResponse.response.urls[0];
      }
      const res = await updateHobby(rest);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        if (onSucess) onSucess();

        dispatch(closeAdminModal());
        return fulfillWithValue(res);
      }
      if (onError) {
        onError();
      }
      dispatch(
        openToast({ type: "error", message: getApiMessage(res?.statusCode) }),
      );
      return rejectWithValue(res);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      return rejectWithValue(error);
    }
  },
);

//Add Hobby
export const AddHobbyAction = createAsyncThunk(
  "Hobby/add",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    let { file, filter, onError, onSucess, ...rest } = payload;
    try {
      if (file) {
        const uploadFilesResponse = await uploadFile({
          file: file,
          uploadFor: "image",
        });

        if (uploadFilesResponse.status === 0) {
          dispatch(
            openToast({ type: "error", message: uploadFilesResponse?.message }),
          );
          return rejectWithValue(uploadFilesResponse);
        }
        rest.image = uploadFilesResponse.response.urls[0];
      }

      const res = await addHobby(rest);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        if (onSucess) onSucess();
        dispatch(closeAdminModal());
        const response = await getHobby(filter);
        if (response.status === 1) {
          return fulfillWithValue(response);
        }
      }
      if (onError) {
        onError();
      }
      dispatch(
        openToast({ type: "error", message: getApiMessage(res?.statusCode) }),
      );
      return rejectWithValue(res);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      return rejectWithValue(error);
    }
  },
);
